import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=bba07874"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"
import style0 from "./swiper.vue?vue&type=style&index=0&id=bba07874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports